import React, { useState } from 'react';
import { Autocomplete, TextField } from '@mui/material';
import { GridRenderEditCellParams, useGridApiContext } from '@mui/x-data-grid';

interface AutocompleteEditCellProps {
    params: GridRenderEditCellParams;
    options: any[] | undefined;
    freeSolo?: boolean;
    multiple?: boolean;
    disableClearable?: boolean;
    getOptionLabel?: (option: any) => string;
    onSave: (value: string) => void;
}

export function AutocompleteEditCell(props: AutocompleteEditCellProps) {
    const {
        params,
        options,
        freeSolo,
        onSave,
        getOptionLabel,
        multiple,
        disableClearable,
    } = props;
    const { id, field } = params || {};
    const apiRef = useGridApiContext();
    const [value, setValue] = useState<any>('');
    const [inputValue, setInputValue] = useState<any>('');

    const handleValueChange = (_: any, newValue: any) => {
        apiRef.current.setEditCellValue({
            id,
            field,
            value: newValue,
        });
        setValue(newValue);
        onSave(newValue?.id);
    };

    return (
        <Autocomplete
            fullWidth
            disableClearable={disableClearable}
            multiple={multiple}
            options={options || []}
            getOptionLabel={getOptionLabel}
            freeSolo={freeSolo}
            value={value || null}
            onChange={handleValueChange}
            inputValue={inputValue}
            onInputChange={(_, newInputValue) => {
                setInputValue(newInputValue);
            }}
            renderInput={(params) => <TextField {...params} />}
        />
    );
}
